<template>
    <div>
        <transition>

            <!-- Editable -->
            <div v-if="state === 'editable'" class="uk-card uk-card-default uk-card-small">

                <header class="uk-card-header">

                    <div class="uk-grid-small" uk-grid>

                        <h2 class="uk-width-expand uk-flex uk-flex-middle">
                            <span class="uk-badge uk-badge-large uk-margin-small-right">2</span>
                            <span>Способ доставки</span>
                        </h2>

                    </div>

                </header>

                <div class="uk-card-body">

                    <div class="uk-grid-small uk-child-width-auto uk-flex uk-flex-center" uk-grid>

                        <div class="uk-width-1-2 uk-width-1-3@s tm-choose">
                            <input v-model="deliveryType.pickup" :value="false" class="uk-radio" id="type-3"
                                   type="radio" name="radio3">
                            <label for="type-3">
                                <div class="tm-choose-title">Доставка</div>
                            </label>
                        </div>

                        <div class="uk-width-1-2 uk-width-1-3@s tm-choose">
                            <input v-model="deliveryType.pickup" :value="true" class="uk-radio" id="type-4" type="radio"
                                   name="radio3">
                            <label for="type-4">
                                <div class="tm-choose-title">Самовывоз</div>
                            </label>
                        </div>

                    </div>
                    <div v-if="deliveryType.pickup === false">
                        <h3 class="uk-text-center">Адрес доставки</h3>

                        <div class="uk-grid-small" uk-grid>

                            <div class="uk-width-1-2">
                                <label class="uk-form-label">Город <span class="uk-text-danger">*</span></label>
                                <input v-model="Delivery.city" class="uk-input" type="text">
                            </div>

                            <div class="uk-width-1-1">
                                <label class="uk-form-label">Адрес <span class="uk-text-danger">*</span></label>
                                <textarea v-model="Delivery.address" class="uk-textarea" rows="3"></textarea>
                            </div>

                        </div>
                        <label class="uk-form-label">Примечание</label>
                        <textarea v-model="Delivery.note" class="uk-textarea" rows="3"></textarea>
                    </div>
                    <div v-else>
                        <h3 class="uk-text-center">Самовывоз</h3>

                        <div class="uk-grid-small" uk-grid>
                            <div class="uk-width-1-1">
                                <!--<h3 class="uk-text-center">Мы на карте</h3>-->
                            </div>
                            <div class="uk-width-1-1">
                                <iframe src="https://yandex.ru/map-widget/v1/-/CBQFrVRPcD" width="100%"
                                        height="400" frameborder="0"></iframe>
                            </div>
                        </div>
                    </div>

                    <div class="uk-text-center uk-margin-medium">
                        <button @click.prevent="$emit('cart::nextStep')" class="uk-button uk-button-secondary">
                            <span>Далее</span>
                            <span class="uk-margin-small-left uk-icon" uk-icon="icon: arrow-right"></span>
                        </button>
                    </div>

                </div>

            </div>

            <!-- Ready -->
            <div v-if="state === 'completed'" class="uk-card uk-card-default uk-card-small">

                <header class="uk-card-header">

                    <div class="uk-grid-small" uk-grid>

                        <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                        <span class="uk-badge uk-badge-large uk-margin-small-right cart-badge-success">
                                            <span class="uk-icon" uk-icon="icon: check"></span>
                                        </span>
                            <span class="uk-text-muted">Способ доставки</span>
                        </h2>

                        <div class="uk-width-auto uk-flex uk-flex-middle">
                            <a @click.prevent="$emit('cart::editStep')" class="uk-link-muted">
                                <span class="uk-icon" uk-icon="icon: pencil"></span>
                                <span>Редактировать</span>
                            </a>
                        </div>

                    </div>

                </header>

                <div class="uk-card-body">

                    <div class="uk-grid-small uk-text-small uk-text-muted" uk-grid>

                        <div class="uk-width-1-3">
                            <dl class="uk-description-list">

                                <dt>Способ доставки</dt>
                                <dd v-if="deliveryType.pickup === false">Доставка</dd>
                                <dd v-else>Самовывоз</dd>

                            </dl>
                        </div>
                        <div v-if="deliveryType.pickup === false">
                            <div class="uk-width-expand">
                                <dl class="uk-description-list">

                                    <dt>Адрес доставки</dt>
                                    <dd>{{ Delivery.city }} {{ Delivery.address }}</dd>

                                </dl>
                            </div>

                            <div class="uk-width-1-1">
                                <dl class="uk-description-list">

                                    <dt>Примечание</dt>
                                    <dd>
                                        {{ Delivery.note }}
                                    </dd>

                                </dl>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            state: {
                'type': String,
                'required': true,
                'default': 'next'
            },
            data: {
                'type': Object,
                'required': true,
                'default': {}
            },
        },
        data() {
            return {
                Delivery: this.data.ShopCustomerDelivery,
                deliveryType: {
                    pickup: true
                }
            }
        },
        mounted() {
            this.$emit('update:data', {ShopCustomerDelivery: this.Delivery});
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// CartDelivery.vue?faaeaafc